angular.module('dwtCreatePEClaimModule').factory('DwtCreatePE', [
  'CreateDwtPEReqService',
  'ViewDwtDetailService',
  '$sessionStorage',
  function (CreateDwtPEReqService, ViewDwtDetailService, $sessionStorage) {
    function DwtCreatePE(createPEDataParms, intermediaryId) {
      this.returnObj = {};
      this.claimId = createPEDataParms.peClaimId;
      this.userType = $sessionStorage.usertype;
      this.flag = createPEDataParms.flag;
      this.eventId = createPEDataParms.eventId;
      this.shareholderId = createPEDataParms.shareholderId;
      this.intermediaryId = intermediaryId;
      this.loginUserId = createPEDataParms.loginUserId;
      this.isin = createPEDataParms.isin;
      this.dwtPerSecurity = createPEDataParms.dwtPerSecurity;
      this.shareclassId = createPEDataParms.shareClassId;
      this.rsinNumber = '';
      this.tin = '';
      this.securityAccountNo = '';
      this.firstName = '';
      this.lastName = '';
      this.postalCode = '';
      this.email = '';
      this.city = '';
      this.country = 'NLD';
      this.phoneNumber = '';
      this.position = 0;
      this.claimAmount = '';
      this.address = '';
      this.paymentReference = '';
      this.fundManager = '';
      this.shareClassName = '';
      this.claimType = 'PE';
      this.searchclickedflag = false;
      this.onloadFlag = false;
    }
    DwtCreatePE.prototype.createDwtPERequest = function (
      successCallback,
      errorCallback
    ) {
      this.searchclickedflag = false;
      this.onloadFlag = false;
      if (this.claimId) {
        this.claimAmount = this.dwtPerSecurity * this.position;
        CreateDwtPEReqService.editDWTPERequest(
          this,
          this.eventId,
          this.claimId
        ).then(successCallback, errorCallback);
      } else {
        this.claimAmount = this.dwtPerSecurity * this.position;
        CreateDwtPEReqService.createDwtPERequest(this).then(
          successCallback,
          errorCallback
        );
      }
    };
    DwtCreatePE.prototype.viewDWTPERequest = function (
      successCallback,
      errorCallback
    ) {
      this.searchclickedflag = false;
      this.onloadFlag = true;
      ViewDwtDetailService.getDwtClaimsDetailsView(
        this.claimId,
        this.userType,
        this.eventId
      ).then(successCallback, errorCallback);
    };
    DwtCreatePE.prototype.searchSans = function (
      successCallback,
      errorCallback
    ) {
      this.searchclickedflag = true;
      this.onloadFlag = false;
      CreateDwtPEReqService.searchSans(this).then(
        successCallback,
        errorCallback
      );
    };
    return DwtCreatePE;
  },
]);
